import { makeStyles } from '@material-ui/core';
import Colors from '../../components/Colors';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
    background: '#F2F2F2',
    border: ' 0.5px solid rgba(0, 0, 0, 0.2)',
    boxSizing: 'border-box',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    marginTop: '2%',
  },
  root: {
    display: 'flex',
    flexFlow: 'column',
    width: '100%',
    padding: '2% 0 3% 0%',
    background: '#F2F2F2',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  showAll: {
    display: 'flex',
    flexFlow: 'column',
    width: '100%',
    padding: '2% 0 3% 0%',
  },
  small: {
    display: 'none',
    margin: '2% 0 2% 0',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
    },
  },
  containerMap: {
    width: '70%',
    height: '300px',
    border: '0.5px solid rgba(0, 0, 0, 0.5)',
    zIndex: 0,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  box: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row',
    borderBottom: '0.5px solid #fcb51d',
    marginTop: '1%',
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column',
    },
  },
  buttons: {
    border: '0px solid transparent',
    marginRight: '2%',
    borderRadius: '0px',
    color: Colors.secundary,
    fontWeight: 'bolder',
  },
  buttonActive: {
    marginRight: '2%',
    backgroundColor: Colors.secundary,
    color: '#404040',
    fontWeight: 'bolder',
  },

}));
